import React, { useState } from 'react';
import { galleryImages } from '../mock';
import { X } from 'lucide-react';

const Gallery = () => {
  const [filter, setFilter] = useState('all');
  const [lightboxImage, setLightboxImage] = useState(null);

  const filteredImages = filter === 'all'
    ? galleryImages
    : galleryImages.filter(img => img.category === filter);

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center justify-center bg-cover bg-center" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1600')" }}>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Our Gallery
          </h1>
          <p className="text-xl text-gray-200">
            A visual journey through our culinary creations and warm ambience
          </p>
        </div>
      </section>

      {/* Gallery Filters */}
      <section className="section-padding">
        <div className="container">
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <button
              onClick={() => setFilter('all')}
              className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                filter === 'all'
                  ? 'bg-[#E84118] text-white shadow-lg'
                  : 'bg-white text-[#2C3E50] border-2 border-gray-200 hover:border-[#E84118]'
              }`}
            >
              All
            </button>
            <button
              onClick={() => setFilter('food')}
              className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                filter === 'food'
                  ? 'bg-[#E84118] text-white shadow-lg'
                  : 'bg-white text-[#2C3E50] border-2 border-gray-200 hover:border-[#E84118]'
              }`}
            >
              Our Dishes
            </button>
            <button
              onClick={() => setFilter('ambience')}
              className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                filter === 'ambience'
                  ? 'bg-[#E84118] text-white shadow-lg'
                  : 'bg-white text-[#2C3E50] border-2 border-gray-200 hover:border-[#E84118]'
              }`}
            >
              Restaurant Ambience
            </button>
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredImages.map((image) => (
              <div
                key={image.id}
                className="relative group cursor-pointer overflow-hidden rounded-lg shadow-md hover-lift"
                onClick={() => setLightboxImage(image)}
              >
                <img
                  src={image.url}
                  alt={image.caption}
                  className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-all duration-300 flex items-end">
                  <div className="p-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <p className="font-semibold">{image.caption}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredImages.length === 0 && (
            <div className="text-center py-12 text-gray-500">
              No images found in this category.
            </div>
          )}
        </div>
      </section>

      {/* Lightbox */}
      {lightboxImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setLightboxImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-[#F39C12] transition-colors"
            onClick={() => setLightboxImage(null)}
          >
            <X className="w-8 h-8" />
          </button>
          <div className="max-w-5xl max-h-[90vh]">
            <img
              src={lightboxImage.url}
              alt={lightboxImage.caption}
              className="max-w-full max-h-[85vh] object-contain rounded-lg"
            />
            <p className="text-white text-center mt-4 text-lg">{lightboxImage.caption}</p>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="section-padding bg-[#FFF8F0]">
        <div className="container text-center">
          <h2 className="text-3xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif", color: '#2C3E50' }}>
            Experience It Yourself
          </h2>
          <p className="text-xl text-gray-700 mb-8">
            Visit us and create your own delicious memories
          </p>
          <a href="tel:+919876543210" className="btn-primary">
            Reserve Your Table
          </a>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
